import { tracked } from "@glimmer/tracking";

export interface StepInit {
  velocity?: number;
  active?: boolean;
}

export class Step {
  @tracked velocity: number;
  @tracked active: boolean;

  constructor(init: StepInit = {}) {
    this.velocity = init.velocity ?? 0;
    this.active = init.active ?? false;
  }

  get enabled(): boolean {
    return this.velocity !== 0;
  }

  cycleVelocity(): number {
    if (this.velocity === 0) {
      this.velocity = 0.5;
    } else if (this.velocity === 0.5) {
      this.velocity = 1.0;
    } else {
      this.velocity = 0;
    }
    return this.velocity;
  }

  serialize(): { velocity: number } {
    return {
      velocity: this.velocity,
    };
  }

  static deserialize(data: { velocity?: number }): Step {
    return new Step({ velocity: data?.velocity ?? 0 });
  }
}
